<template>
    <div class="pt-10 pr-0 pb-[60px] pl-5 md:pl-10 w-full bg-grayBg rounded-3xl text-black">
        <h2 class="md:mb-[30px] text-2xl font-medium">
            Подобрать форму плитки
        </h2>
        <div class="flex items-center justify-between gap-10 h-full">
            <div class="shape-content relative w-[208px] h-[208px]">
                <svg :class="[hovered === types.square ? 'active' : '', hovered === null ? 'default' : '']"
                     stroke-width="5" width="147" height="147" viewBox="0 0 147 147" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="146" height="146" stroke="#F4F4F4"></rect>
                </svg>
                <svg :class="[hovered === types.rectangle ? 'active' : '', hovered === null ? 'default' : '']"
                     stroke-width="5" width="147" height="90" viewBox="0 0 147 90" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="146" height="89" stroke="#F4F4F4"></rect>
                </svg>
                <svg :class="[hovered === types.octagon ? 'active' : '', hovered === null ? 'default' : '']"
                     stroke-width="3" width="208" height="208" viewBox="0 0 208 208" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path
                        d="M30.8436 30.8436L104 0.541198L177.156 30.8436L207.459 104L177.156 177.156L104 207.459L30.8436 177.156L0.541198 104L30.8436 30.8436Z"
                        stroke="#F4F4F4"></path>
                </svg>
                <svg :class="[hovered === types.hexagon ? 'active' : '', hovered === null ? 'default' : '']"
                     stroke-width="3" width="182" height="208" viewBox="0 0 182 208" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.43336 52.2887L91 0.57735L180.567 52.2887V155.711L91 207.423L1.43336 155.711V52.2887Z"
                          stroke="#F4F4F4"></path>
                </svg>
                <svg :class="[hovered === types.romb ? 'active' : '', hovered === null ? 'default' : '']"
                     stroke-width="3" width="209" height="209" viewBox="0 0 209 209" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <rect x="104.98" y="1.2635" width="146" height="146" transform="rotate(45.2661 104.98 1.2635)"
                          stroke="#F4F4F4"></rect>
                </svg>
                <svg class="line"
                     :class="[hovered === null ? 'default change' : 'active']"
                     stroke-width="3" width="3" height="75" viewBox="0 0 1 75" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <line x1="0.5" y1="-2.18557e-08" x2="0.500003" y2="75" stroke="#F4F4F4"></line>
                </svg>
                <svg class="line-hidden"
                     :class="[hovered === null ? '' : 'active']"
                     stroke-width="3" width="3" height="75" viewBox="0 0 1 75" fill="none"
                     xmlns="http://www.w3.org/2000/svg">
                    <line x1="0.5" y1="-2.18557e-08" x2="0.500003" y2="75" stroke="#F4F4F4"></line>
                </svg>
            </div>
            <ul class="shape-tabs">
                <li @mouseover="onMouseEnter(types.square)"
                    @mouseout="onMouseLeave"
                    class="shape-tab font-medium cursor-pointer transition rounded-l-3xl"
                    :class="{'bg-baseColor': hovered === types.square}">
                    <Link class="shape-link pt-2 pr-10 pb-2 pl-5"
                          :href="route('catalog', {category_title:'plitka', forms: JSON.stringify([types.square])})">
                        Квадратная
                    </Link>
                </li>
                <li @mouseover="onMouseEnter(types.rectangle)"
                    @mouseout="onMouseLeave"
                    class="shape-tab font-medium cursor-pointer transition rounded-l-3xl"
                    :class="{'bg-baseColor': hovered === types.rectangle}">
                    <Link class="shape-link pt-2 pr-10 pb-2 pl-5"
                          :href="route('catalog', {category_title:'plitka', forms: JSON.stringify([types.rectangle])})">
                        Прямоугольная
                    </Link>
                </li>
                <li @mouseover="onMouseEnter(types.octagon)"
                    @mouseout="onMouseLeave"
                    class="shape-tab font-medium cursor-pointer transition rounded-l-3xl"
                    :class="{'bg-baseColor': hovered === types.octagon}">
                    <Link class="shape-link pt-2 pr-10 pb-2 pl-5"
                          :href="route('catalog', {category_title:'plitka', forms: JSON.stringify([types.octagon])})">
                        Октагон
                    </Link>
                </li>
                <li @mouseover="onMouseEnter(types.hexagon)"
                    @mouseout="onMouseLeave"
                    class="shape-tab font-medium cursor-pointer transition rounded-l-3xl"
                    :class="{'bg-baseColor': hovered === types.hexagon}">
                    <Link class="shape-link pt-2 pr-10 pb-2 pl-5"
                          :href="route('catalog', {category_title:'plitka', forms: JSON.stringify([types.hexagon])})">
                        Шестигранник
                    </Link>
                </li>
                <li @mouseover="onMouseEnter(types.romb)"
                    @mouseout="onMouseLeave"
                    class="shape-tab font-medium cursor-pointer transition rounded-l-3xl"
                    :class="{'bg-baseColor': hovered === types.romb}">
                    <Link class="shape-link pt-2 pr-10 pb-2 pl-5"
                          :href="route('catalog', {category_title:'plitka', forms: JSON.stringify([types.romb])})">
                        Ромб
                    </Link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    name: 'FigureChoice',
    components: {Link},
    data() {
        return {
            hovered: null,
            types: {
                square: 1,
                rectangle: 2,
                octagon: 16,
                hexagon: 17,
                romb: 24,
            },
            mobileInterval: null,
        }
    },
    methods: {
        onMouseEnter(id) {
            this.hovered = id;
        },
        onMouseLeave() {
            this.hovered = null;
        },
        initMobileRotation() {
            // const isMobile = window.innerWidth <= 768;
            // if (!isMobile) {
            //     return;
            // }

            // если уже запущено — не дублируем
            if (this.mobileInterval) return;

            const shapeIds = Object.values(this.types);
            let idx = 0;
            // сразу покажем первый
            this.hovered = shapeIds[idx];
            idx = (idx + 1) % shapeIds.length;

            this.mobileInterval = setInterval(() => {
                this.hovered = shapeIds[idx];
                idx = (idx + 1) % shapeIds.length;
            }, 4000);
        },
    },
    mounted() {
        this.initMobileRotation();
        // при изменении ориентации или размера экрана можно перезапустить/остановить,
        // если нужно реагировать на ресайз:
    },
};

</script>

<style scoped>
.shape-link {
    display: block;
}

.shape-content svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
    transition: all 1s;
}

.shape-content svg.line {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
    max-height: 100%;
}

.shape-content svg path,
.shape-content svg rect,
.shape-content svg.line-hidden line {
    stroke-dashoffset: 700;
    stroke-dasharray: 700;
    transition: all 1s;
}

.shape-content svg.default path,
.shape-content svg.default rect,
.shape-content svg.default.line-hidden line {
    stroke-dashoffset: 0;
}

.shape-content svg.line path,
.shape-content svg.line rect {
    stroke-dashoffset: 0;
    stroke-dasharray: 0;
    transition: all 1s;
}

.shape-content svg.line {
    transform: translate(0, -50%);
    left: calc(100% + 100px);
}

.shape-content svg.line-hidden.active {
    /* transition-delay: 1s; */
    transform: translate(-50%, -50%) rotate(135deg);
}

.shape-content svg path,
.shape-content svg rect,
.shape-content svg line {
    stroke: var(--main-color);
}

.shape-content svg.active path,
.shape-content svg.active rect,
.shape-content svg.active line {
    stroke-dashoffset: 0;
    stroke: var(--main-color);
}

.shape-content svg.line.active {
    animation: lineActive 1s forwards;
}

.shape-content svg.line.change {
    animation: lineChange 1s forwards;
}

@keyframes lineActive {
    0% {
        transform: translate(0, -50%) rotate(0);
        left: calc(100% + 100px);
    }
    50% {
        transform: translate(0, -50%) rotate(-75%);
    }
    100% {
        left: 50%;
        transform: translate(-50%, -50%) rotate(-135deg);
    }
}

@keyframes lineChange {
    0% {
        left: 50%;
        transform: translate(-50%, -50%) rotate(-135deg);
    }
    50% {
        transform: translate(0, -50%) rotate(-75%);
    }
    100% {
        transform: translate(0, -50%) rotate(0);
        left: calc(100% + 100px);
    }
}
</style>
